module.exports = __webpack_public_path__ + "img/17_Upper-rectrum.a5cb0242.png";